import axios from "axios";

const rawToken =
  process.env.REACT_APP_GITHUB_TOKEN || process.env.REACT_APP_GH_TOKEN || "";
const token = typeof rawToken === "string" ? rawToken.trim() : "";

function resolveClientConfig() {
  if (typeof window === "undefined") {
    return {
      baseURL: "https://api.github.com",
      useVercelQueryProxy: false,
      useProxy: false,
      clientToken: token,
    };
  }

  const host = window.location.hostname;
  const origin = window.location.origin;

  const useVercelProxy =
    host.endsWith(".vercel.app") ||
    host === "githubfinder.adnwebs.com" ||
    process.env.REACT_APP_DEPLOY_TARGET === "vercel";

  const useNetlifyProxy =
    !useVercelProxy &&
    (host.endsWith(".netlify.app") ||
      process.env.REACT_APP_DEPLOY_TARGET === "netlify");

  if (useVercelProxy) {
    return {
      baseURL: `${origin}/api/proxy`,
      useVercelQueryProxy: true,
      useProxy: true,
      clientToken: "",
    };
  }
  if (useNetlifyProxy) {
    return {
      baseURL: `${origin}/.netlify/functions/github-proxy`,
      useVercelQueryProxy: false,
      useProxy: true,
      clientToken: "",
    };
  }
  return {
    baseURL: "https://api.github.com",
    useVercelQueryProxy: false,
    useProxy: false,
    clientToken: token,
  };
}

const { baseURL, useVercelQueryProxy, useProxy, clientToken } =
  resolveClientConfig();

/** True when auth is available (client token or server proxy with token). */
export const hasGithubToken = Boolean(clientToken || useProxy);

const github = axios.create({
  baseURL,
  headers: {
    Accept: "application/vnd.github+json",
    "X-GitHub-Api-Version": "2022-11-28",
    ...(clientToken ? { Authorization: `Bearer ${clientToken}` } : {}),
  },
});

/** Vercel: one file `/api/proxy` — fold path + axios params into ?target= */
if (useVercelQueryProxy) {
  github.interceptors.request.use((config) => {
    let path = config.url || "";
    if (!path.startsWith("/")) path = `/${path}`;
    const params = config.params;
    if (params && typeof params === "object" && Object.keys(params).length) {
      const sp = new URLSearchParams();
      for (const [k, v] of Object.entries(params)) {
        if (v !== undefined && v !== null) sp.append(k, String(v));
      }
      const q = sp.toString();
      if (q) path += (path.includes("?") ? "&" : "?") + q;
    }
    config.params = { target: path };
    config.url = "";
    return config;
  });
}

export function parseRateLimitHeaders(res) {
  const remaining = res.headers["x-ratelimit-remaining"];
  const reset = res.headers["x-ratelimit-reset"];
  return {
    remaining: remaining != null ? Number(remaining) : null,
    resetAt: reset != null ? Number(reset) * 1000 : null,
  };
}

export default github;
